module.exports = "/static/assets/725089014557d28fd2c38904a6326b81.svg";